import state from './fileupload.state'
import mutations from './fileupload.mutations'
import actions from './fileupload.actions'

export default {
  state,
  mutations,
  actions
}
